import React from "react";
import "./cart.style.scss";
import { Card, Input } from "antd";
import { SITEURL } from "../../../../api";

export default function BankCart(props) {
    return (
        <div
            style={{ padding: "25px 15px" }}
            className="row ant-card gx-card-widget mycards d-flex"
        >
            <div className="temx-bank-card-component">
                <div className="desc">
                    {" "}
                    <div className="logo">
                        <img src={SITEURL + props.data.icon} alt="bank" />
                    </div>
                    <div className="detail">
                        <h4>{props.data.bankName}</h4>
                        <p>
                            تاریخ اضافه شدن :{" "}
                            {new Date(
                                props.data.creationDate
                            ).toLocaleDateString("fa-IR")}
                        </p>
                        <p>وضعیت : {props.data.status}</p>
                    </div>
                </div>
                <div className="numbers">
                    <div className="items">
                        <label>شماره کارت :</label>
                        <p>{props.data.cardNumber}</p>
                    </div>
                    <div className="items">
                        <label>شماره شبا : </label>
                        <p title="شماره شبا" readOnly={true}>
                            {" "}
                            {props.data.iBan}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
